import { useSyncExternalStore } from 'react'
import { beginLayoutSwap } from '@papan/core-ui/ui'

/**
 * Phone-viewport detection for the mobile shell swap. Media-query based
 * (not user-agent) so DevTools device emulation, real phones, and split
 * windows all behave identically — and resizing re-picks the shell live.
 * 767px = below Tailwind's `md` breakpoint.
 */
const PHONE_QUERY = '(max-width: 767px)'

function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(PHONE_QUERY)
  // Crossing the breakpoint swaps the whole shell (`RootShell`): open the swap
  // window BEFORE React re-renders, so unsaved drafts in the screens it
  // unmounts are kept for the new shell (#897, `useDraftState`).
  const handler = () => { beginLayoutSwap(); onChange() }
  mql.addEventListener('change', handler)
  return () => mql.removeEventListener('change', handler)
}

function getSnapshot(): boolean {
  return window.matchMedia(PHONE_QUERY).matches
}

export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
